const BACKEND_URL = process.env.REACT_APP_SIGNALING_SERVER || 'https://backend-aurixstaff.aurixdevelopment.sbs';

// Send notification for new message (MENTION ONLY)
export async function notifyNewMessage(chatId, senderId, senderName, messageText, memberIds, mentions = [], isEveryoneMention = false) {
  try {
    const response = await fetch(`${BACKEND_URL}/api/notify/message`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        chatId,
        senderId,
        senderName,
        messageText,
        memberIds,
        mentions, // Include mentions array
        isEveryoneMention // Include @everyone flag
      })
    });

    const data = await response.json();
    console.log('Mention notification sent:', data);
    return data;
  } catch (error) {
    console.error('Error sending mention notification:', error);
    return null;
  }
}

// Send notification for new todo
export async function notifyNewTodo(todoId, title, assignedTo, assignedBy, assignerName, groupId = null) {
  try {
    const response = await fetch(`${BACKEND_URL}/api/notify/todo`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        todoId,
        title,
        assignedTo,
        assignedBy,
        assignerName,
        groupId
      })
    });

    const data = await response.json();
    console.log('Todo notification sent:', data);
    return data;
  } catch (error) {
    console.error('Error sending todo notification:', error);
    return null;
  }
}

// Send notification for completed todo
export async function notifyTodoCompleted(todoId, title, completedBy, completedByName, assignedBy) {
  try {
    const response = await fetch(`${BACKEND_URL}/api/notify/todo-completed`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        todoId,
        title,
        completedBy,
        completedByName,
        assignedBy
      })
    });

    const data = await response.json();
    console.log('Todo completion notification sent:', data);
    return data;
  } catch (error) {
    console.error('Error sending todo completion notification:', error);
    return null;
  }
}
